import {
  Box,
  Button,
  Link,
  Heading,
  Text,
  Collapse,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import Layout from "../../containers/Layout";
import VideoTemplate from "../VideoTemplate/VideoTemplate";
import Seo from "../Seo/Seo";

const mainTextContent = `

I founded SWA to help students like you achieve their Spanish language goals. Since then, I’ve guided 100+ learners on their journey to mastering Spanish, whether they’re preparing to relocate, ace an exam, or simply enjoy their next holiday in a Spanish-speaking country.

My approach? Efficient, engaging, and fun. Forget about boring textbooks or endless theory! With me, you’ll use Spanish in the real world from day one.

Now, let’s get learning!

`;

// Componente CustomLink sin el prop 'isExternal' para abrir los enlaces en la misma página

const WhyMe = () => {
  const [openFAQ, setOpenFAQ] = useState({});

  const toggleFAQ = (index) => {
    setOpenFAQ((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const faqs = [
    {
      question: "What qualifications does Alex have?",
      answer:
        "Alex holds a BSc (Hons) Spanish Degree in Education Studies from the Royal University of Santiago de Compostela and postdoctoral training in Teaching Spanish as a Second Language from International House.",
    },
    {
      question: "What teaching experience does Alex have?",
      answer:
        "Alex has worked as a Spanish private tutor from 2010 until now, teaching students of all levels, including business and one-to-one groups.",
    },
    {
      question: "Which platforms can I find Alex on?",
      answer:
        "You can find Alex on Instagram, TikTok, YouTube (@spanishwithalex), and iTalki as a verified Spanish teacher.",
    },
    {
      question: "Where does Alex live?",
      answer:
        "Alex lives in the wonderful land of Galicia, Spain, where seafood and coastlines shine. This beautiful region in northwest Spain is known for its stunning Atlantic coastline, rich Celtic heritage, and some of the best seafood in the world!",
    },
    {
      question: "What Spanish levels do you teach?",
      answer:
        "I teach students of all levels - from complete beginners to advanced learners. Whether you're just starting your Spanish journey or looking to perfect your fluency, I adapt my teaching methods to match your current level and learning goals.",
    },
    {
      question: "How long are the Spanish lessons?",
      answer:
        "My Spanish lessons are typically 60 minutes long, which provides the perfect balance for effective learning without overwhelming you. This duration allows us to cover new material, practice conversation, and review previous lessons while keeping you engaged throughout the session.",
    },
    {
      question: "What are Alex's hobbies and interests?",
      answer:
        "I'm naturally curious and passionate about photography, and I love exploring new places — I've lived in many different cities, including thirteen years in London. I'm fascinated by the sea and animals, especially dogs. Swimming has always been a big part of my life, whether in pools, rivers, or the ocean.\n\nThese days, I enjoy cycling and going on bike touring adventures. I love reading philosophy and psychology books, and I really enjoy meeting new people. I'm also a bit of a nerd — I love video games (though I used to play more), board games, computers, and coding. In fact, I built this website myself!\n\nI believe that to be a good teacher, you should always remain a student. People say I'm patient and a great listener. I always have projects on the go and like to keep a productive daily routine. I'm also excited to learn Italian and Portuguese in the future!",
    },
  ];

  return (
    <Layout mt={10}>
      <Seo
        title="Why Learn Spanish With Alex"
        description="Meet Alex: a native Spanish teacher from Galicia with 100+ students guided to fluency. Qualifications, experience, and teaching approach."
        path="/why-me"
      />
      <VideoTemplate
        imageUrl="/images/titulos.jpg"
        imageAlt="Descripción alternativa de la imagen"
        mainTitle="Engaging, Personalised, and Fun: Your Route to Mastering Spanish!"
        subTitle=""
        mainText={mainTextContent}
        linkPath="https://www.italki.com/en/teacher/6018279"
        showButton={false}
        buttonLabel="Reviews on Italki"
      />
      <Box mt={6} px={3}>
        <Button
          as="a"
          href="/what-students-say"
          colorScheme="red"
          variant="outline"
          size="md"
          width={{ base: "100%", md: "auto" }}
          mb={{ base: 3, md: 0 }}
          mr={{ base: 0, md: 3 }}
        >
          Video Reviews by Students
        </Button>
        <Button
          as="a"
          href="https://www.italki.com/en/teacher/6018279"
          target="_blank"
          rel="noopener noreferrer"
          colorScheme="red"
          variant="outline"
          size="md"
          width={{ base: "100%", md: "auto" }}
        >
          Reviews on Italki
        </Button>
      </Box>

      {/* FAQ Section */}
      <Box mt={12} mb={8}>
        <Heading as="h2" size="lg" mb={6} textAlign="center">
          Frequently Asked Questions
        </Heading>

        {faqs.map((faq, index) => (
          <Box
            key={index}
            mb={4}
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            p={4}
          >
            <Button
              onClick={() => toggleFAQ(index)}
              variant="ghost"
              width="100%"
              justifyContent="flex-start"
              textAlign="left"
              fontWeight="semibold"
              fontSize={{ base: "0.95rem", md: "md" }}
              p={0}
              h="auto"
              whiteSpace="normal"
              wordBreak="break-word"
              lineHeight="1.4"
              _hover={{ bg: "transparent" }}
            >
              {faq.question}
            </Button>
            <Collapse in={openFAQ[index]}>
              <Text mt={3} color="gray.600" lineHeight="1.6">
                {faq.answer}
              </Text>
            </Collapse>
          </Box>
        ))}
      </Box>

      {/* SEO Footer - Hidden */}
      <Box position="absolute" left="-9999px" top="-9999px">
        <Text>
          Spanish with Alex 🔴 — Online Spanish teacher | Learn Spanish online |
          Fun, practical lessons BSc Spanish Degree in Education Studies |
          Postdoctoral Training | Teaching experience 2010-2020 Instagram,
          TikTok, YouTube: @spanishwithalex | iTalki
        </Text>
      </Box>
    </Layout>
  );
};

export default WhyMe;
